var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsVertical = function SvgDotsVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#dedede",
    viewBox: "0 0 256 256"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156 128a28 28 0 1 1-28-28 28 28 0 0 1 28 28Zm-28-52a28 28 0 1 0-28-28 28 28 0 0 0 28 28Zm0 104a28 28 0 1 0 28 28 28 28 0 0 0-28-28Z"
  })));
};
export default SvgDotsVertical;